const SectionStyle = {
  marginTop: "100px",
  marginBottom: "100px",
};

export default SectionStyle;
